import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ApexDPS from "./ApexDPS";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ApexDPS />
  </React.StrictMode>
);
